import { Type } from 'typebox';
export const PersonUpdateInfoRequest = Type.Object({
    name: Type.Optional(Type.String({ minLength: 1 })),
    mobileNumber: Type.Optional(Type.String()),
    language: Type.Optional(Type.String({ minLength: 1 }))
}, { minProperties: 1 });
export const PersonUpdateInfoPayload = Type.Unknown();
export const PersonEmailChangeRequest = Type.Object({
    email: Type.String({ minLength: 1 }),
    language: Type.Optional(Type.String({ minLength: 1 }))
});
export const PersonEmailChangeRequestPayload = Type.Unknown();
export const PersonEmailChangeVerifyRequest = Type.Object({
    token: Type.String({ minLength: 1 })
});
export const PersonEmailChangeVerifyPayload = Type.Object({
    email: Type.String({ minLength: 1 }),
    passwordNeeded: Type.Boolean()
});
export class HttpPersonResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async updateInfo(request, options) {
        if (request.name === undefined &&
            request.mobileNumber === undefined &&
            request.language === undefined) {
            throw new Error('Person update requires at least one defined field.');
        }
        await this.#httpClient.post({
            body: request,
            bodySchema: PersonUpdateInfoRequest,
            path: '/person/update_info',
            payloadSchema: PersonUpdateInfoPayload,
            signal: options?.signal
        });
    }
    async requestEmailChange(request, options) {
        await this.#httpClient.post({
            body: request,
            bodySchema: PersonEmailChangeRequest,
            path: '/person/email_change/request',
            payloadSchema: PersonEmailChangeRequestPayload,
            signal: options?.signal
        });
    }
    async verifyEmailChange(request, options) {
        return await this.#httpClient.post({
            body: request,
            bodySchema: PersonEmailChangeVerifyRequest,
            path: '/person/email_change/verify',
            payloadSchema: PersonEmailChangeVerifyPayload,
            signal: options?.signal
        });
    }
}
